import { just, Maybe, nothing } from 'maybeasy';
import { action, computed, makeObservable, observable } from 'mobx';
import { error } from '../ErrorHandling';
import { errorAlert, FlashAlert } from '../Notifications/Types';
import { ProgramDetailResource } from '../ProgramStore/Types';
import { TPlainTextKey } from '../Translations';
import { LearningPartnersResource, LearningPartnersState, loading, ready, waiting } from './Types';

class LearningPartnersStore {
  @observable
  state: LearningPartnersState;

  constructor() {
    makeObservable(this);

    this.state = waiting();
  }

  @action
  loading = (programDetailResource: ProgramDetailResource) => {
    this.state = loading(programDetailResource);
  };

  @action
  ready = (learningPartnersResource: LearningPartnersResource) => {
    this.state = ready(learningPartnersResource);
  };

  @computed
  get learningPartners(): Maybe<LearningPartnersResource> {
    switch (this.state.kind) {
      case 'ready':
        return just(this.state.learningPartnersResource);
      case 'loading':
      case 'waiting':
      case 'error':
        return nothing();
    }
  }

  @action
  error = (msg: TPlainTextKey) => {
    this.state = error(msg);
  };

  @computed
  get notification(): Maybe<FlashAlert> {
    switch (this.state.kind) {
      case 'error':
        return just(this.state).map(errorAlert);
      case 'ready':
      case 'loading':
      case 'waiting':
        return nothing();
    }
  }
}

export default LearningPartnersStore;
